import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();

  // ✅ Add login state
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem("token"));

  useEffect(() => {
    setIsLoggedIn(!!localStorage.getItem("token"));
  }, [location]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    setIsLoggedIn(false); // 🧠 Trigger re-render
    alert("Logged out successfully!");
    navigate('/login');
  };

  return (
    <nav className="navbar navbar-expand-lg bg-dark navbar-dark" style={{marginTop: 0, paddingTop: 0}}>
      <div className="container-fluid" style={{marginTop: '10px'}}>
        <Link className="navbar-brand" to="/">I-Notebook</Link>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
          aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <Link className={`nav-link ${location.pathname === "/" ? "active" : ""}`} to="/">Home</Link>
            </li>
            <li className="nav-item">
              <Link className={`nav-link ${location.pathname === "/about" ? "active" : ""}`} to="/about">About</Link>
            </li>
          </ul>

          {/* 🔥 Clean login/logout logic */}
          {!isLoggedIn ? (
            <form className="d-flex">
              <Link className="btn btn-primary mx-2" to="/login">Login</Link>
              <Link className="btn btn-primary mx-2" to="/signup">Signup</Link>
            </form>
          ) : (
            <button className="btn btn-primary mx-2" onClick={handleLogout}>Logout</button>
          )}
        </div>
      </div>
    </nav>
  );
}
